import { VCol } from 'vuetify/lib/components/VGrid';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSpacer } from 'vuetify/lib/components/VGrid';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(VDataTable, {
    attrs: {
      headers: _vm.tabela.headers,
      items: _vm.relatoriosUnidades,
      search: _vm.tabela.opcoes.pesquisa,
      "sort-by": _vm.tabela.opcoes.ordenarPor,
      "sort-desc": _vm.tabela.opcoes.decrescente,
    },
    scopedSlots: _vm._u(
      [
        {
          key: "top",
          fn: function () {
            return [
              _c(
                VRow,
                [
                  _c(
                    VCol,
                    { attrs: { cols: "12", md: "4" } },
                    [
                      _c("app-sort", {
                        model: {
                          value: _vm.tabela.opcoes,
                          callback: function ($$v) {
                            _vm.$set(_vm.tabela, "opcoes", $$v)
                          },
                          expression: "tabela.opcoes",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(VSpacer),
                  _c(
                    VCol,
                    { attrs: { cols: "12", md: "4" } },
                    [
                      _c("app-search", {
                        model: {
                          value: _vm.tabela.opcoes,
                          callback: function ($$v) {
                            _vm.$set(_vm.tabela, "opcoes", $$v)
                          },
                          expression: "tabela.opcoes",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ]
          },
          proxy: true,
        },
        {
          key: `body.append`,
          fn: function () {
            return [
              _c(
                "tr",
                [
                  _c("td", { attrs: { align: "center", colspan: "2" } }, [
                    _c(
                      "strong",
                      { staticClass: "subtitle-2 grey--text text--darken-2" },
                      [_vm._v("TOTAL")]
                    ),
                  ]),
                  _vm._l(_vm.relatorio.idiomas, function (idioma) {
                    return _c(
                      "td",
                      { key: idioma.id, attrs: { align: "center" } },
                      [_c("strong", [_vm._v(_vm._s(idioma.quantidade))])]
                    )
                  }),
                ],
                2
              ),
            ]
          },
          proxy: true,
        },
      ],
      null,
      true
    ),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }